import { divaActions } from '../actions';

export default (divaConfig, { divaEnabled = false } = {}) => {
  const initialState = {
    ...divaConfig,
  };

  if (!initialState.enabled && divaEnabled) {
    initialState.enabled = true;
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case divaActions.UPDATE_DETAILS:
        return {
          ...state,
          details: action.payload,
        };

      case divaActions.SET_DIVA_OUTCOME:
        return { ...state, outcome: action.payload };

      default:
        return state;
    }
  };
};
